<template>
  <v-select
    v-model="pdv"
    :error-messages="errors"
    outlined
    :loading="loading"
    :disabled="loading"
    label="Ponto de Venda"
    :items="getPdvs"
    item-text="description"
    item-value="id"
  ></v-select>
</template>

<script>
import {
  mapGetters,
  mapActions,
} from 'vuex'
import axios from '@/plugins/axios'

export default {

  components: {},
  props: {
    value: {},
    errors: {},
  },

  data: () => ({
    loading: false,
    pdv: '',
    pdvs: [],
  }),

  watch: {
    value(val) {
      this.category = val
    },
    pdv() {
      this.$emit('input', this.pdv)
      this.$emit('change')
    },

  },

  created() {
    this.loadPdvs
    this.pdvs = this.getPdvs
    this.pdv = this.value
  },
  computed: {
    ...mapGetters('select', ['getPdvs']),
    ...mapActions('select', ['loadPdvs']),
  },
  methods: {},
}
</script>
